import { PrimaryButton } from "components/Button/style";
import { CustomInput } from "components/CustomInput";
import { ModalCustom } from "components/ModalCustom";
import { Required } from "components/Required";
import FileUpload from "components/UploadArquivos";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { IDadosAutorizacaoManual } from "../../interfaces/IAcoesLote";
import { ContainerBotoes, LarguraModal, TextoSecao } from "./style";

const EXTENSOES_ACEITAS = ".png,.jpg,.jpeg,.pdf";
const ID_INPUT_ARQUIVO = "arquivoAutorizacaoManual";

interface IProps {
  show: boolean;
  handleClose: () => void;
  idAutorizacaoInicial: string;
  onConfirmar: (dados: IDadosAutorizacaoManual) => Promise<boolean>;
  carregando: boolean;
}

export function AutorizacaoManualModal({
  show,
  handleClose,
  idAutorizacaoInicial,
  onConfirmar,
  carregando,
}: IProps) {
  const [idAutorizacao, setIdAutorizacao] = useState(idAutorizacaoInicial);
  const [arquivo, setArquivo] = useState<File | null>(null);
  const idPreenchido = idAutorizacao.trim();

  useEffect(() => {
    if (show) {
      setIdAutorizacao(idAutorizacaoInicial);
      setArquivo(null);
    }
  }, [show, idAutorizacaoInicial]);

  async function confirmar() {
    if (!arquivo || !idPreenchido) {
      return;
    }

    if (await onConfirmar({ idAutorizacao: idPreenchido, arquivo })) {
      handleClose();
    }
  }

  const fecharSeLivre = carregando ? () => {} : handleClose;

  return (
    <>
      <LarguraModal />
      <ModalCustom
        show={show}
        handleClose={fecharSeLivre}
        title="Informar autorização manual"
        dialogClassName="modal-autorizacao-manual"
        centered
        footer
        footerTools={
          <ContainerBotoes>
            <PrimaryButton
              type="button"
              outline
              variante="primary"
              onClick={fecharSeLivre}
            >
              Cancelar
            </PrimaryButton>
            <PrimaryButton
              type="button"
              onClick={confirmar}
              disabled={!arquivo || !idPreenchido || carregando}
            >
              Confirmar autorização
            </PrimaryButton>
          </ContainerBotoes>
        }
      >
        <TextoSecao>Dados da autorização</TextoSecao>
        <div className="d-flex gap-3">
          <Form.Group className="flex-fill" controlId="idAutorizacaoManual">
            <Form.Label>
              ID autorização <Required />
            </Form.Label>
            <CustomInput
              type="text"
              placeholder="Informe o ID autorização"
              value={idAutorizacao}
              onChange={(e) => setIdAutorizacao(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="flex-fill">
            <Form.Label htmlFor={ID_INPUT_ARQUIVO}>
              Arquivo (PDF autorização) <Required />
            </Form.Label>
            <FileUpload
              id={ID_INPUT_ARQUIVO}
              inputAccept={EXTENSOES_ACEITAS}
              comMaxWidth={false}
              onFileUpload={setArquivo}
            />
          </Form.Group>
        </div>
      </ModalCustom>
    </>
  );
}
